import e from "@dialpad/dialtone-tokens/layered/themes/tokens-125-colors.css?inline";
//#region themes/125.js
var t = { brand: {
	css: e,
	name: "125"
} };
//#endregion
export { t as default };
